import { unit } from '@ant-design/cssinjs';
const genSizeStyle = token => {
  const {
    componentCls,
    tableExpandColumnWidth,
    calc
  } = token;
  const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize) => ({
    ["".concat(componentCls).concat(componentCls, "-").concat(size)]: {
      fontSize,
      ["\n        ".concat(componentCls, "-title,\n        ").concat(componentCls, "-footer,\n        ").concat(componentCls, "-cell,\n        ").concat(componentCls, "-thead > tr > th,\n        ").concat(componentCls, "-tbody > tr > th,\n        ").concat(componentCls, "-tbody > tr > td,\n        tfoot > tr > th,\n        tfoot > tr > td\n      ")]: {
        padding: "".concat(unit(paddingVertical), " ").concat(unit(paddingHorizontal))
      },
      ["".concat(componentCls, "-filter-trigger")]: {
        marginInlineEnd: unit(calc(paddingHorizontal).div(2).mul(-1).equal())
      },
      ["".concat(componentCls, "-expanded-row-fixed")]: {
        margin: "".concat(unit(calc(paddingVertical).mul(-1).equal()), " ").concat(unit(calc(paddingHorizontal).mul(-1).equal()))
      },
      ["".concat(componentCls, "-tbody")]: {
        // ========================= Nest Table ===========================
        ["".concat(componentCls, "-wrapper:only-child ").concat(componentCls)]: {
          marginBlock: unit(calc(paddingVertical).mul(-1).equal()),
          marginInline: "".concat(unit(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal()), " ").concat(unit(calc(paddingHorizontal).mul(-1).equal()))
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      ["".concat(componentCls, "-selection-extra")]: {
        paddingInlineStart: unit(calc(paddingHorizontal).div(4).equal())
      }
    }
  });
  return {
    ["".concat(componentCls, "-wrapper")]: Object.assign(Object.assign({}, getSizeStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle)), getSizeStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall))
  };
};
export default genSizeStyle;